import { createApp } from 'vue'
import options from './Accordion.options'

const el = '.kb-component--accordion'
export default function (Store) {
    const DOMs = document.querySelectorAll(el)
    if (DOMs.length) {
        DOMs.forEach((accordion) => {
            if (accordion.hasAttribute('data-v-app')) return false
            const component = createApp(options).use(Store)
            component.mount(accordion)

            accordion.querySelectorAll('a').forEach((a) => {
                a.setAttribute('tabindex', -1)
            })
        })
    }
}
